import * as session from '@xmatters/redux/actions/session';

export default function httpError() {
  return next => action => {
    const { meta, error, payload } = action;

    if (!meta) {
      return next(action);
    }

    const { xmApi, xmWebApp } = meta;

    if ((xmApi || xmWebApp) && error && payload.code === 401) {
      return next(session.timeout({ payload, error }));
    }

    return next(action);
  };
}
